export default __webpack_public_path__ + "static/media/no-title-payment.26661b02.svg";